/* Dreama cart drawer. Config comes from snippets/dreama-cart.liquid. */
(function () {
  if (window.DreamaCart) return;
  var C = window.DreamaCartConfig || {};
  var root = document.getElementById("dc");
  if (!root) return;

  var $ = function (id) { return document.getElementById(id); };
  var bodyEl = $("dcBody"), footEl = $("dcFoot"), barEl = $("dcBar"), countEl = $("dcCount");
  var panel = root.querySelector(".dc-panel");

  var cart = C.cart || { items: [], item_count: 0, total_price: 0, currency: "USD" };
  var pendingAdds = 0; // skeleton rows while an add is in flight
  var busyKeys = {}; // line keys with a change in flight
  var error = "";
  var isOpen = false;
  var lastFocus = null;
  var queue = Promise.resolve();

  // ---- Product data -------------------------------------------------------
  var cocoa = {};
  ["one", "sub"].forEach(function (type) {
    ((C.cocoa || {})[type] || []).forEach(function (v) {
      var m = /(\d+)\s*Pack/i.exec(v.t || "");
      cocoa[v.id] = { id: v.id, type: type, pack: m ? +m[1] : 1, price: v.p, compare: v.c, sp: v.sp || (C.spFallback || {})[v.id] || null };
    });
  });
  function findCocoa(type, pack) {
    for (var id in cocoa) if (cocoa[id].type === type && cocoa[id].pack === pack) return cocoa[id];
    return null;
  }
  var gifts = C.gifts || {};
  var P = C.protection || {};
  function isGift(item) { return !!gifts[item.variant_id]; }
  function isProtect(item) { return +item.variant_id === +P.id; }
  function isMain(item) { return !isGift(item) && !isProtect(item); }

  // ---- Helpers ------------------------------------------------------------
  function money(cents) {
    var v = cents / 100;
    try {
      return new Intl.NumberFormat(C.locale || undefined, {
        style: "currency", currency: cart.currency || "USD", currencyDisplay: "narrowSymbol",
        minimumFractionDigits: v % 1 === 0 ? 0 : 2, maximumFractionDigits: 2
      }).format(v);
    } catch (e) { return "$" + v.toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function img(url, w) {
    if (!url) return "";
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }
  function imgTag(url, cls) {
    cls = cls || "dc-img";
    return url ? '<img class="' + cls + '" src="' + esc(img(url, 160)) + '" alt="" loading="lazy">' : '<span class="' + cls + '"></span>';
  }
  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function api(url, body) {
    var opts = { headers: { Accept: "application/json" } };
    if (body) {
      opts.method = "POST";
      opts.headers["Content-Type"] = "application/json";
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || "Something went wrong. Please try again.");
        return j;
      });
    });
  }
  // Run cart writes one at a time so they never race each other.
  function enqueue(fn) {
    var p = queue.then(fn, fn);
    queue = p.catch(function () {});
    return p;
  }

  // ---- Shipping protection preference -------------------------------------
  function protectOn() {
    if (!P.id) return false;
    var saved = store("dc_protect");
    if (saved === "1" || saved === "0") return saved === "1";
    return (P.defaultOffIn || []).indexOf(C.country) === -1;
  }

  // ---- Gifts + protection rules -------------------------------------------
  // Returns {variantId: true} for every gift the given lines qualify for.
  function wantedGifts(lines) {
    var qty = {};
    lines.forEach(function (l) { if (!gifts[l.id]) qty[l.id] = (qty[l.id] || 0) + l.quantity; });
    var want = {};
    (C.rules || []).forEach(function (rule) {
      var n = rule.when.reduce(function (s, id) { return s + (qty[id] || 0); }, 0);
      if (n >= rule.min) rule.gifts.forEach(function (g) { want[g] = true; });
    });
    return want;
  }
  // What the extras (gifts + protection) should be for a given set of lines: {variantId: qty}
  function wantedExtras(lines) {
    var want = {};
    Object.keys(wantedGifts(lines)).forEach(function (id) { want[id] = 1; });
    var hasMain = lines.some(function (l) { return l.quantity > 0 && !gifts[l.id] && +l.id !== +P.id; });
    if (P.id && protectOn() && hasMain) want[P.id] = 1;
    return want;
  }
  function cartLines() {
    return cart.items.map(function (i) { return { id: i.variant_id, quantity: i.quantity, key: i.key }; });
  }
  // Works out the update map (existing lines -> new qty) and the items to add
  // so the cart's extras match "lines". Lines passed in can carry changed quantities.
  function planExtras(lines) {
    var want = wantedExtras(lines), updates = {}, have = {}, adds = [];
    cart.items.forEach(function (i) {
      if (isMain(i)) return;
      var target = want[i.variant_id] && !have[i.variant_id] ? 1 : 0;
      if (target) have[i.variant_id] = true;
      if (i.quantity !== target) updates[i.key] = target;
    });
    Object.keys(want).forEach(function (id) {
      if (have[id]) return;
      var item = { id: +id, quantity: 1 };
      if (gifts[id]) item.properties = { _gift: "1" };
      adds.push(item);
    });
    return { updates: updates, adds: adds };
  }
  // Brings gifts + protection in line with the rules.
  function syncExtras() {
    var plan = planExtras(cartLines());
    var needUpdate = Object.keys(plan.updates).length;
    if (!needUpdate && !plan.adds.length) return Promise.resolve();
    var p = Promise.resolve();
    if (needUpdate) p = p.then(function () { return api("/cart/update.js", { updates: plan.updates }); });
    if (plan.adds.length) p = p.then(function () { return addWithExtras([], plan.adds); });
    // A sold-out gift should never break the cart; just show what's there.
    return p.catch(function (e) { console.warn("Dreama cart: extras sync failed", e); }).then(fetchCart);
  }
  // Adds items plus extras in one request. If that fails (e.g. a gift sold out), retries without the extras.
  function addWithExtras(items, extra) {
    return api("/cart/add.js", { items: items.concat(extra) }).catch(function (e) {
      if (!extra.length || !items.length) throw e;
      return api("/cart/add.js", { items: items });
    });
  }

  // ---- Cart state ---------------------------------------------------------
  function fetchCart() {
    return api("/cart.js").then(function (c) { cart = c; render(); return c; });
  }
  function packs() {
    return cart.items.reduce(function (s, i) {
      var c = cocoa[i.variant_id];
      return s + (c ? c.pack * i.quantity : 0);
    }, 0);
  }
  function giftsValue(ids) {
    return ids.reduce(function (s, id) { return s + ((gifts[id] || {}).value || 0); }, 0);
  }

  // ---- Cart reservation countdown -----------------------------------------
  // Starts when the cart first has something in it and lasts for this browser
  // session. It hides once it runs out or the cart is empty; it never restarts on its own.
  var T = C.timer || {};
  var tick = null;
  function session(k, v) {
    try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { return null; }
  }
  function renderTimer() {
    if (!cart.items.some(isMain)) { session("dc_reserve", null); return; }
    var timerEl = footEl.querySelector(".dc-timer");
    if (!timerEl || !T.label) return;
    var dl = +session("dc_reserve") || 0;
    if (!dl) { dl = Date.now() + (T.minutes || 10) * 6e4; session("dc_reserve", dl); }
    var r = dl - Date.now();
    if (r <= 0) { timerEl.hidden = true; return; }
    var m = Math.floor(r / 6e4), s = Math.floor((r % 6e4) / 1e3);
    timerEl.hidden = false;
    timerEl.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5M9 2h6"/></svg>' +
      "<span>" + esc(T.label) + " <b>" + m + ":" + (s < 10 ? "0" : "") + s + "</b></span>";
  }

  // ---- Rendering ----------------------------------------------------------
  function render() {
    var count = cart.items.reduce(function (s, i) { return s + (isProtect(i) ? 0 : i.quantity); }, 0);
    countEl.textContent = count ? "(" + count + ")" : "";
    updateBubble(count);

    // Free gifts progress bar (shipping is free on every order, so this is gifts only)
    var n = packs(), need = C.packsForPerks || 2;
    if (n > 0) {
      var done = n >= need;
      var unlock = Object.keys(wantedGifts([{ id: (findCocoa("one", need) || {}).id, quantity: 1 }]));
      var value = giftsValue(unlock);
      var txt = (done ? C.perksUnlocked : C.perksLocked)
        .replace("{n}", need - n).replace("{count}", unlock.length).replace("{value}", value ? money(value) : "");
      barEl.hidden = false;
      barEl.innerHTML = '<p class="dc-bar-txt">' + (done ? "✓ " : "") + txt + "</p>" +
        '<div class="dc-bar-track"><span style="width:' + Math.min(100, (n / need) * 100) + '%"></span></div>';
    } else {
      barEl.hidden = true;
    }

    var html = "";
    if (error) html += '<div class="dc-err" role="alert">' + esc(error) + "</div>";
    for (var s = 0; s < pendingAdds; s++) html += '<div class="dc-line dc-skel"><div class="dc-img"></div><div class="dc-info"><i></i><i></i><i></i></div></div>';

    var main = cart.items.filter(isMain);
    var free = cart.items.filter(isGift);

    if (!main.length && !pendingAdds) {
      html += '<div class="dc-empty"><p>Your cart is empty</p><a class="dc-btn" href="' + esc(C.shopUrl || "/") + '">Shop Deep Sleep Cocoa</a></div>';
    }
    main.forEach(function (i) { html += lineHtml(i); });
    if (free.length && main.length) {
      html += '<p class="dc-gifts-h">Your free gifts</p>';
      free.forEach(function (i) { html += giftHtml(i); });
    }
    bodyEl.innerHTML = html;
    renderFoot(main.length);
    renderTimer();
  }

  function lineHtml(i) {
    var c = cocoa[i.variant_id];
    var compare = c && c.compare > i.final_price ? c.compare * i.quantity : (i.original_line_price > i.final_line_price ? i.original_line_price : 0);
    var plan = i.selling_plan_allocation && i.selling_plan_allocation.selling_plan.name;
    var sub = [i.variant_title, plan].filter(Boolean).join(" · ");
    var busy = busyKeys[i.key] ? " is-busy" : "";
    return '<div class="dc-item' + busy + '" data-key="' + esc(i.key) + '">' +
      '<div class="dc-line">' + imgTag(i.image) +
      '<div class="dc-info">' +
      '<div class="dc-top"><p class="dc-name">' + esc(i.product_title) + '</p>' +
      '<button type="button" class="dc-rm" data-act="rm" aria-label="Remove ' + esc(i.product_title) + '"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg></button></div>' +
      (sub ? '<p class="dc-var">' + esc(sub) + "</p>" : "") +
      '<div class="dc-row"><div class="dc-qty">' +
      '<button type="button" data-act="dec" aria-label="Decrease quantity">−</button><span>' + i.quantity + '</span>' +
      '<button type="button" data-act="inc" aria-label="Increase quantity">+</button></div>' +
      '<div class="dc-price">' + (compare ? "<s>" + money(compare) + "</s>" : "") + "<b>" + money(i.final_line_price) + "</b></div></div>" +
      "</div></div>" +
      offersHtml(i, c) +
      "</div>";
  }

  // Upgrade offers shown under a cocoa line. One at a time: Subscribe & Save first
  // (for one-time lines), then the bigger pack once they are subscribed.
  function offersHtml(i, c) {
    if (!c) return "";
    var out = "", unit = i.final_price;
    var need = C.packsForPerks || 2;

    // 1) One-time -> Subscribe & Save
    if (c.type === "one") {
      var s = findCocoa("sub", c.pack);
      if (s && s.sp && s.price < unit) {
        var save = (unit - s.price) * i.quantity;
        out += '<div class="dc-offer">' +
          '<p class="dc-offer-label">Subscribe &amp; Save</p>' +
          '<p class="dc-offer-h">Save ' + money(save) + " on this order and every refill</p>" +
          '<ul class="dc-offer-list">' +
          "<li><b>Cancel anytime</b> in one click — no commitment</li>" +
          "<li><b>Skip or pause</b> whenever you need a break</li>" +
          "<li>Delivered every 30 days, <b>free shipping</b></li>" +
          "</ul>" +
          '<button type="button" class="dc-offer-btn" data-act="swap" data-to="' + s.id + '">Switch to Subscribe &amp; Save <span aria-hidden="true">→</span></button>' +
          "</div>";
      }
    }
    if (out) return out;

    // 2) Bigger pack: show exactly what the upgrade unlocks
    if (c.pack < need) {
      var up = findCocoa(c.type, need);
      if (up) {
        var after = cartLines().map(function (l) { return l.key === i.key ? { id: up.id, quantity: l.quantity } : l; });
        var now = wantedGifts(cartLines()), then = wantedGifts(after);
        var unlocks = Object.keys(then).filter(function (id) { return !now[id]; });
        var extra = Math.max(0, up.price - unit) * i.quantity;
        var perPack = up.price / up.pack;
        var names = unlocks.map(function (id) { return (gifts[id] || {}).name; }).filter(Boolean);
        out += '<div class="dc-offer">' +
          '<div class="dc-offer-row">' +
          (unlocks.length ? '<div class="dc-offer-thumbs">' + unlocks.map(function (id) { return imgTag((gifts[id] || {}).img, "dc-og-img"); }).join("") + "</div>" : "") +
          '<div class="dc-offer-copy">' +
          '<p class="dc-offer-label">Most customers upgrade</p>' +
          '<p class="dc-offer-h">Get the ' + up.pack + ' Pack \u00B7 ' + money(perPack) + " per pack</p>" +
          (unlocks.length ? '<p class="dc-offer-sub" title="' + esc(names.join(" + ")) + '">+ ' + unlocks.length + " free gift" + (unlocks.length > 1 ? "s" : "") + " <s>" + money(giftsValue(unlocks)) + "</s></p>" : "") +
          "</div></div>" +
          '<button type="button" class="dc-offer-btn" data-act="swap" data-to="' + up.id + '">Upgrade for +' + money(extra) + ' <span aria-hidden="true">\u2192</span></button>' +
          "</div>";
      }
    }
    return out;
  }

  function giftHtml(i) {
    var g = gifts[i.variant_id] || {};
    return '<div class="dc-line dc-gift">' +
      imgTag(i.image) +
      '<div class="dc-info"><p class="dc-name">' + esc(g.name || i.product_title) + "</p>" +
      '<div class="dc-row"><span class="dc-free">FREE</span><div class="dc-price">' +
      (g.value ? "<s>" + money(g.value) + "</s>" : "") + "<b>" + money(0) + "</b></div></div></div></div>";
  }

  function renderFoot(hasMain) {
    if (!hasMain) { footEl.innerHTML = ""; return; }
    var on = protectOn();
    var busy = pendingAdds || Object.keys(busyKeys).length;
    var protectRow = P.id ?
      '<div class="dc-protect">' +
      '<span class="dc-protect-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg></span>' +
      '<div class="dc-protect-txt"><b>Shipping protection</b><small>Covers loss, theft &amp; damage in transit</small></div>' +
      '<span class="dc-protect-price">' + money(P.price || 0) + "</span>" +
      '<button type="button" class="dc-switch" role="switch" aria-checked="' + on + '" aria-label="Shipping protection" data-foot="protect"><span></span></button>' +
      "</div>" : "";
    footEl.innerHTML = protectRow +
      '<p class="dc-timer" hidden></p>' +
      '<div class="dc-total"><span>Total</span><span>' + money(cart.total_price) + "</span></div>" +
      '<a class="dc-btn dc-checkout' + (busy ? " is-busy" : "") + '" href="' + esc(C.checkoutUrl || "/checkout") + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>' +
      'Secure Checkout <span aria-hidden="true">→</span></a>' +
      '<p class="dc-trust">' +
      '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M1 4h13v12H1zM14 8h4l4 4v4h-8z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>Free shipping</span>' +
      '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>60-night guarantee</span>' +
      "</p>";
  }

  function updateBubble(count) {
    document.querySelectorAll("#cart-icon-bubble").forEach(function (a) {
      var el = a.querySelector(".wt-header__panel__counter");
      if (!count) { if (el) el.remove(); return; }
      if (!el) {
        el = document.createElement("span");
        el.className = "wt-header__panel__counter";
        var label = a.querySelector(".wt-header__panel__label");
        a.insertBefore(el, label);
      }
      el.textContent = count;
    });
  }

  // ---- Open / close -------------------------------------------------------
  function open() {
    if (isOpen) return;
    isOpen = true;
    lastFocus = document.activeElement;
    render();
    renderTimer();
    tick = setInterval(renderTimer, 1000);
    root.setAttribute("aria-hidden", "false");
    root.classList.add("is-open");
    document.documentElement.classList.add("dc-lock");
    setTimeout(function () { panel.focus({ preventScroll: true }); }, 30);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    error = "";
    clearInterval(tick);
    root.classList.remove("is-open");
    root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("dc-lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  // ---- Actions ------------------------------------------------------------
  // Adds items plus any gifts/protection they need in ONE request. Opens the drawer immediately.
  function add(items, opts) {
    opts = opts || {};
    items = (items || []).filter(function (x) { return x && x.id; }).map(function (x) {
      var o = { id: +x.id, quantity: +(x.quantity || 1) };
      if (x.selling_plan) o.selling_plan = +x.selling_plan;
      if (x.properties && Object.keys(x.properties).length) o.properties = x.properties;
      return o;
    });
    if (!items.length) return Promise.resolve(cart);
    error = "";
    pendingAdds++;
    if (opts.open !== false) open(); else render();
    return enqueue(function () {
      var after = cartLines().concat(items.map(function (x) { return { id: x.id, quantity: x.quantity }; }));
      var plan = planExtras(after);
      return addWithExtras(items, plan.adds)
        .catch(function (e) { error = e.message; })
        .then(function () { pendingAdds--; return fetchCart(); })
        .then(syncExtras)
        .then(function () { render(); return cart; });
    });
  }

  function change(key, qty) {
    busyKeys[key] = true;
    error = "";
    render();
    return enqueue(function () {
      // Change the line and fix gifts/protection in the same request.
      var after = cartLines().map(function (l) { return l.key === key ? { id: l.id, quantity: qty, key: key } : l; });
      var plan = planExtras(after);
      plan.updates[key] = qty;
      return api("/cart/update.js", { updates: plan.updates })
        .then(function (c) { cart = c; })
        .catch(function (e) { error = e.message; })
        .then(function () { delete busyKeys[key]; render(); return syncExtras(); })
        .then(function () { render(); return cart; });
    });
  }

  // Swap a cocoa line to another variant (pack upgrade or one-time -> subscribe).
  function swap(key, toId) {
    var line = cart.items.filter(function (i) { return i.key === key; })[0];
    var to = cocoa[toId];
    if (!line || !to) return Promise.resolve();
    busyKeys[key] = true;
    error = "";
    render();
    return enqueue(function () {
      var item = { id: to.id, quantity: line.quantity };
      if (to.type === "sub" && to.sp) item.selling_plan = to.sp;
      var after = cartLines().filter(function (l) { return l.key !== key; }).concat([{ id: to.id, quantity: line.quantity }]);
      var plan = planExtras(after);
      return addWithExtras([item], plan.adds)
        .then(function () { return api("/cart/change.js", { id: key, quantity: 0 }); })
        .then(function (c) { cart = c; })
        .catch(function (e) { error = e.message; })
        .then(function () { delete busyKeys[key]; return fetchCart(); })
        .then(syncExtras)
        .then(function () { render(); return cart; });
    });
  }

  function setProtection(on) {
    store("dc_protect", on ? "1" : "0");
    busyKeys._protect = true; // holds checkout until the cart matches the toggle
    render();
    return enqueue(syncExtras).then(function () { delete busyKeys._protect; render(); return cart; });
  }

  function refresh() {
    return enqueue(function () { return fetchCart().then(syncExtras); });
  }

  // Theme product forms (other product pages) route through here.
  function addForm(form, button) {
    var fd = new FormData(form);
    var item = { id: fd.get("id"), quantity: fd.get("quantity") || 1, properties: {} };
    if (fd.get("selling_plan")) item.selling_plan = fd.get("selling_plan");
    fd.forEach(function (v, k) {
      var m = /^properties\[(.+)\]$/.exec(k);
      if (m && v !== "") item.properties[m[1]] = v;
    });
    if (button) button.classList.add("loading");
    return add([item]).then(function (c) {
      if (button) button.classList.remove("loading");
      return c;
    });
  }

  // ---- Events -------------------------------------------------------------
  root.addEventListener("click", function (e) {
    if (e.target.closest("[data-dc-close]")) { close(); return; }
    var btn = e.target.closest("[data-act]");
    if (!btn) return;
    var line = btn.closest("[data-key]");
    if (!line || busyKeys[line.dataset.key]) return;
    var key = line.dataset.key;
    var item = cart.items.filter(function (i) { return i.key === key; })[0];
    if (!item) return;
    var act = btn.dataset.act;
    if (act === "inc") change(key, item.quantity + 1);
    else if (act === "dec") change(key, item.quantity - 1);
    else if (act === "rm") change(key, 0);
    else if (act === "swap") swap(key, +btn.dataset.to);
  });
  footEl.addEventListener("click", function (e) {
    if (e.target.closest("[data-foot=protect]")) { setProtection(!protectOn()); return; }
    var a = e.target.closest(".dc-checkout");
    if (a && a.classList.contains("is-busy")) {
      // Wait for in-flight cart changes before leaving for checkout.
      e.preventDefault();
      a.textContent = "Updating cart…";
      queue.then(function () { window.location.href = a.getAttribute("href"); });
    }
  });
  document.addEventListener("keydown", function (e) {
    if (!isOpen) return;
    if (e.key === "Escape") close();
    if (e.key === "Tab") {
      var f = panel.querySelectorAll("button:not([disabled]), a[href]");
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // Header cart icon opens the drawer instead of going to /cart.
  document.addEventListener("click", function (e) {
    var t = e.target.closest(".wt-cart__trigger, #cart-icon-bubble, a[href='/cart']");
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopPropagation();
    open();
    refresh();
  }, true);

  // ---- Public API + UpCart compatibility ----------------------------------
  // Pages that were written for UpCart keep working without edits.
  window.DreamaCart = { open: open, close: close, add: add, addForm: addForm, change: change, refresh: refresh, setProtection: setProtection, get cart() { return cart; } };
  window.upcartOpenCart = open;
  window.upcartRefreshCart = refresh;
  window.UpCart = { openCart: open, closeCart: close, refreshCart: refresh };
  document.addEventListener("upcart:open", open);

  render();
  // Fix gifts/protection for carts built before this drawer existed (e.g. by Vex on the old theme).
  if (cart.items.length) setTimeout(function () { enqueue(syncExtras); }, 1500);
})();
